<style lang="scss" scoped>
.order-form {
    border: 1px solid var(--dark);
    @media screen and (max-width: 1023.98px) {
        border: none;
    }
}
</style>

<template>
    <div class="order-form">
        <el-form @submit="submit" :loading="loading" :success="success" :error="server_error" submitText="Vraag een offerte aan">
            <p class="mb-16">Teambuilding</p>
            <div class="row mb-24">
                <el-input v-model="data.date" class="col-12 col-md-6" type="date" label="Datum (meerdere mogelijk)" rules="required" />
                <el-input v-model="data.location" class="col-12 col-md-6" label="Locatie" rules="required" />
                <el-input v-model="data.people" type="number" class="col-12 col-md-6" label="Aantal personen" placeholder="Aantal.." rules="required" />
                <el-input v-model="data.budget" type="number" class="col-12 col-md-6" label="Budget €/pp. (optioneel)" placeholder="Budget..." />
            </div>

            <p class="mb-16">Contactgegevens</p>
            <div class="row mb-24">
                <el-input v-model="data.first_name" class="col-12 col-md-6" label="Voornaam" rules="required" />
                <el-input v-model="data.last_name" class="col-12 col-md-6" label="Achternaam" rules="required" />
                <el-input v-model="data.email" class="col-12 col-md-6" type="email" label="E-mailadres" rules="required|email" />
                <el-input v-model="data.phone" class="col-12 col-md-6" label="Telefoonnummer" rules="required" />
                <el-input v-model="data.vat" class="col-12 col-md-6" name="btw-nummer" label="BTW nummer" rules="required" />
                <el-input v-model="data.company" class="col-12 col-md-6" label="Bedrijfsnaam" rules="required" />
            </div>

            <p class="mb-8">Opmerkingen</p>
            <p class="small font-weight-light mb-16">Wil je nog een bericht of speciale wensen toevoegen aan je aanvraag?</p>
            <el-input v-model="data.message" type="textarea" label="Bericht" />
        </el-form>
        <success-popover :class="{ active : success}" :title="copyConfig.order_confirmation.title" :description="copyConfig.order_confirmation.description" :cta="copyConfig.order_confirmation.cta"></success-popover>
    </div>
</template>

<script>
import hasForm from '../mixins/has-form'

export default {
    name: "form.el-orders-form",

    mixins: [hasForm],

    props: {
        orders: {
            type: Object,
            default: function() {
                return {
                    activities: [],
                    speakers: [],
                    locations: [],
                    staticItems: [],
                    gifts: [],
                }
            }
        },
        copyConfig: {
            type: Object,
            required: true,
        },
    },

    data: () => ({
        data: {
            date: '',
            location: '',
            people: '',
            budget: '',
            order: [],
            first_name: '',
            last_name: '',
            email: '',
            phone: '',
            vat: '',
            company: '',
            message: ''
        }
    }),

    methods: {
        submit() {
            this.beforeSubmit()
            let data = {
                ...this.data,
                activities: this.orders.activities != null ? this.orders.activities.map(activity => activity.id) : [],
                speakers: this.orders.speakers != null ? this.orders.speakers.map(speaker => speaker.id) : [],
                locations: this.orders.locations != null ? this.orders.locations.map(location => location.id) : [],
                staticItems: this.orders.staticItems != null ? this.orders.staticItems.map(staticItem => staticItem.id) : [],
                gifts: this.orders.gifts != null ? this.orders.gifts.map(gift => gift.id) : [],
                tribeBoxes: this.orders.tribeBoxes != null ? this.orders.tribeBoxes.map(tribeBox => tribeBox.id) : [],
            }
            axios.post('/api/offer', data)
                .then(response => {
                    this.handleSuccess()
                })
                .catch(e => this.handleError(e));
        }
    }
}
</script>